module.exports = __webpack_public_path__ + "img/medIconWhite.51a74f41.png";